import { useEffect } from "react";
import { AlertDialog, Flex, Button } from "@radix-ui/themes";

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "danger" | "warning" | "info";
}

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",
}: ConfirmDialogProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const getVariantColor = () => {
    switch (variant) {
      case "danger":
        return "red";
      case "warning":
        return "orange";
    }
  };

  return (
    <AlertDialog.Root open={isOpen} onOpenChange={onClose}>
      <AlertDialog.Content
        maxWidth="420px"
        className="ConfirmDialogContent"
        style={{ zIndex: 1000 }}
      >
        <AlertDialog.Title className="ConfirmDialogTitle">
          {variant === "danger" && (
            <span style={{ color: "var(--red-9)" }}>⚠️</span>
          )}{" "}
          {title}
        </AlertDialog.Title>

        <AlertDialog.Description className="ConfirmDialogDescription">
          {message}
        </AlertDialog.Description>

        <Flex gap="2" justify="end" mt="4">
          <AlertDialog.Cancel>
            <Button variant="outline" color="gray" size="2" onClick={onClose}>
              {cancelText}
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button
              variant="solid"
              color={getVariantColor()}
              size="2"
              onClick={onConfirm}
            >
              {confirmText}
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}
